



























import Vue, { PropType } from 'vue';
import { Photos } from '@/types';
import { defaultHomeImage, isMobile } from '@/util';
import { EventType } from '@/constants';
import PlusCircleIcon from '@/assets/icons/PlusCircle.vue';
import { mapGetters } from 'vuex';
import { bus } from '@/main';

export default Vue.extend({
  name: 'ImageGrid',
  components: {
    PlusCircleIcon
  },
  data () {
    return {
      observer: {} as IntersectionObserver
    }
  },
  props: {
    sortedPhotos: {
      type: Array as PropType<Photos[]>,
      required: true
    },
    newCount: {
      type: Number,
      required: true
    },
    sortType: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          (entry.target.firstChild as HTMLImageElement).src = ((entry.target.firstChild as HTMLImageElement).dataset.source as string) || '';
          this.observer.unobserve(entry.target);
        }
      })
    }, {
      rootMargin: '0px'
    });
  },
  updated () {
    const elements = document.querySelectorAll('.gridimg');
    elements.forEach((el) => {
      this.observer.observe(el)
    });
  },
  computed: {
    ...mapGetters(['isLoggedInAsAdmin'])
  },
  methods: {
    toggleLightbox (index: number) {
      this.$emit(EventType.TOGGLE_LIGHTBOX, index);
    },
    uploadImages () {
      if (this.isLoggedInAsAdmin) {
        bus.$emit(EventType.VIEW_VERSION);
      } else {
        this.$emit(EventType.UPLOAD_IMAGES);
      }
    },
    onImageError (event: Event) {
      const currentImageElement = (event.target as HTMLImageElement);
      const parentElement = currentImageElement.parentElement;
      if (parentElement) {
        parentElement.remove();
      }
    }
  },
  beforeDestroy () {
    this.observer.disconnect();
  }
});
